class NotificationStore {
    constructor() {
        this.notifications = new Map()
    }

    add(key, notification) {
        this.notifications.set(key, notification)
    }

    get(key) {
        return this.notifications.get(key)
    }

    has(key) {
        return this.get(key) !== null
    }
}

const notificationStore = new NotificationStore()

export {
    notificationStore,
}
